const actions = {
  fetch: (zip, instance, namespace = '') => instance.get(`${namespace}/reference-geo-data`, { params: { zip_code: zip } })
    .then(r => r.data.data[0].attributes),

  divisionName: (abbrev, instance, namespace = '') => instance.get(
    `${namespace}/reference-country-division`,
    { params: { division_abbrev_iso: abbrev } },
  )
    .then(r => r.data.data[0].attributes.divisionLabel),
};

export default actions;
